// extracted by mini-css-extract-plugin
module.exports = {"AllCategoriesHeader":"AllCategoriesHeader___3EFF4","AllCategories":"AllCategories___KxMuF","new":"new___TRSa4","androidAllCategoriesHeader":"androidAllCategoriesHeader___ZmFc9"};